export class Transfers {
  constructor(http) {
    this.http = http;
  }

  fetch(type, filters = [], page = 1, sortingMap = [], search = '') {
    let params = { page, page_size: 15, search: search || undefined };

    filters.forEach(filter => {
      params[`filter_${filter.type}`] = filter.value;
    });

    sortingMap.forEach((mode, header) => {
      if (mode !== 'none') {
        params[header] = mode;
      }
    });

    return this.http.get(`${type}/transfer/`, { params }).then(response => response.data);
  }
}
